import { Box, BoxProps } from '@chakra-ui/react';
import { FC } from 'react';

export interface CardProps extends BoxProps {
  children: React.ReactNode;
}

export const Card: FC<CardProps> = ({ children, ...props }) => {
  return (
    <Box
      bg="white"
      borderRadius="lg"
      p={6}
      border="1px"
      borderColor="gray.200"
      {...props}
    >
      {children}
    </Box>
  );
}; 